export default [
    {
        id: "permission",
        name: "权限管理",
        url: "/permission",
        children: [
            {
                id: "menu",
                name: "菜单管理",
                url: "/permission/menu/list",
            },
            {
                id: "role",
                name: "角色管理",
                url: "/permission/role/list",
            },
            {
                id: "admin",
                name: "管理员管理",
                url: "/permission/admin/list",
            },
            {
                id: "log",
                name: "日志管理",
                url: "/permission/log/list",
            },
        ],
    },
    {
        id: "user",
        name: "用户管理",
        url: "/user",
        children: [
            {
                id: "userList",
                name: "用户列表",
                url: "/user/list",
            },
            {
                id: "userFeedback",
                name: "用户反馈记录",
                url: "/user/feedback",
            }
        ]
    },
    {
        id: "device",
        name: "设备管理",
        url: "/device",
        children: [
            {
                id: "deviceList",
                name: "设备列表",
                url: "/device/list",
            },
            {
                id: "deviceImport",
                name: "导入设备数据列表",
                url: "/device/import",
            },
            {
                id: "deviceNotice",
                name: "配件通知管理",
                url: "/device/notice"
            },
            {
                id: "utilList",
                name: "配件列表",
                url: "/device/util"
            },
            {
                id: "versionList",
                name: "固件版本管理",
                url: "/device/version"
            }
        ]
    },
];
